import { $language } from '@/stores/Language'

const priceFormatter = (amount: number | string, currency: string) => new Intl.NumberFormat($language.get(), {
  style: 'currency',
  currency: currency ?? 'USD',
  currencyDisplay: 'narrowSymbol',
  maximumFractionDigits: 2,
}).format(
  Number.parseFloat(amount.toString()),
)

export {
  priceFormatter,
}
